import type { ThreadRuntimeOption } from "@cmmd-forge/contracts/settings";

export type ThreadRuntimeCapability = {
  readonly id: ThreadRuntimeOption;
  readonly enabled: boolean;
  readonly reason?: string;
};

export type ThreadRuntimeSelection = {
  readonly requestedDefault: ThreadRuntimeOption;
  readonly effectiveDefault: ThreadRuntimeOption;
  readonly capabilities: readonly ThreadRuntimeCapability[];
};

/**
 * Runtime selection resolves a fallback route for new work. Project- or
 * thread-scoped environment ids still win because Forge supports multiple
 * active runtimes at the same time.
 */
export function getDefaultThreadRuntimeCapabilities(): readonly ThreadRuntimeCapability[] {
  return [
    { id: "cloud", enabled: true },
    { id: "desktop-local", enabled: true },
  ];
}

export function resolveEffectiveThreadRuntime(
  requestedDefault: ThreadRuntimeOption,
  capabilities: readonly ThreadRuntimeCapability[],
): ThreadRuntimeOption {
  const requested = capabilities.find((capability) => capability.id === requestedDefault);
  if (requested?.enabled) return requested.id;

  return "cloud";
}

export function resolveThreadRuntimeSelection(input: {
  readonly requestedDefault: ThreadRuntimeOption;
  readonly capabilities?: readonly ThreadRuntimeCapability[];
}): ThreadRuntimeSelection {
  const capabilities = input.capabilities ?? getDefaultThreadRuntimeCapabilities();
  return {
    requestedDefault: input.requestedDefault,
    effectiveDefault: resolveEffectiveThreadRuntime(input.requestedDefault, capabilities),
    capabilities,
  };
}
